var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDialog)?_c('v-dialog',[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.$t('name')))])]),_c('v-card-text')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }